import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["display"],
  _excluded2 = ["as", "children"];
import styled from 'styled-components';
import { filterProps } from '../../utils';
import { useMapStylePropsToCSS } from '../../hooks/useMapStylePropsToCSS';
import { FLEX_RESET_STYLES } from './Flex.styles';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledFlex = styled.div.withConfig({
  displayName: "Flex__StyledFlex",
  componentId: "sc-1nw0qpf-0"
})(props => {
  const _ref = props.$cssStyles,
    {
      display
    } = _ref,
    $cssStyles = _objectWithoutPropertiesLoose(_ref, _excluded);
  return Object.assign({}, FLEX_RESET_STYLES, {
    display: display || 'flex'
  }, $cssStyles);
});

/**
 * A layout container that implements the CSS Flexbox API.
 */
export const Flex = _ref2 => {
  let {
      as = 'div',
      children
    } = _ref2,
    restProps = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  const {
    domProps,
    styleProps
  } = filterProps(restProps);
  const cssStyles = useMapStylePropsToCSS(styleProps);
  return /*#__PURE__*/_jsx(StyledFlex, Object.assign({}, domProps, {
    as: as,
    $cssStyles: cssStyles,
    children: children
  }));
};